import CoinIcon from "/static/images/landing/icons/recovery.svg"
import MagnifyIcon from "/static/images/landing/icons/magnify.svg"
import CheckIcon from "/static/images/landing/icons/check.svg"
import LoadingIcon from "/static/images/landing/icons/loading.svg"

import "./Card.scss"

const iconList = {
  "Simule e conheça as condições": <CoinIcon width={20} heigth={20} />,
  "Explore as opções": <MagnifyIcon width={19} heigth={19} />,
  "Finalize a renegociação": <CheckIcon width={18} heigth={13} />,
  "Acompanhe seus acordos": <LoadingIcon width={20} heigth={20} />,
}

const Card = ({ content }) => {
  const Icon = iconList[content.title]

  return (
    <div className="renegotiation-card">
      <div className="renegotiation-card__icon">{Icon}</div>
      <p className="renegotiation-card__title">{content.title}</p>

      <p className="renegotiation-card__description">{content.description}</p>
    </div>
  )
}

export default Card
